import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border/40 mt-24">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="font-heading text-2xl font-bold tracking-tight">
              Bahama Marketplace
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Authentic Bahamian products from local vendors. Connecting you with the beauty and culture of the Bahamas.
            </p>
          </div>

          {/* Shop */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Shop</h3>
            <nav className="flex flex-col space-y-3 text-sm">
              <Link to="/category/fashion" className="text-muted-foreground hover:text-foreground transition-colors">
                Fashion
              </Link>
              <Link to="/category/mens-fashion" className="text-muted-foreground hover:text-foreground transition-colors pl-3">
                Men's Fashion
              </Link>
              <Link to="/category/womens-fashion" className="text-muted-foreground hover:text-foreground transition-colors pl-3">
                Women's Fashion
              </Link>
              <Link to="/category/kids-fashion" className="text-muted-foreground hover:text-foreground transition-colors pl-3">
                Kids Fashion
              </Link>
              <Link to="/category/electronics" className="text-muted-foreground hover:text-foreground transition-colors">
                Electronics
              </Link>
              <Link to="/category/jewelry" className="text-muted-foreground hover:text-foreground transition-colors">
                Jewelry
              </Link>
              <Link to="/category/beauty-products" className="text-muted-foreground hover:text-foreground transition-colors">
                Beauty Products
              </Link>
            </nav>
          </div>

          {/* For Sellers */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">For Sellers</h3>
            <nav className="flex flex-col space-y-3 text-sm">
              <Link to="/seller" className="text-muted-foreground hover:text-foreground transition-colors">
                Seller Dashboard
              </Link>
              <Link to="/seller/shop" className="text-muted-foreground hover:text-foreground transition-colors">
                Setup Shop
              </Link>
              <Link to="/register" className="text-muted-foreground hover:text-foreground transition-colors">
                Become a Seller
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Support</h3>
            <nav className="flex flex-col space-y-3 text-sm">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Help Center
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Shipping Info
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Returns
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Contact Us
              </a>
            </nav>
          </div>
        </div>

        <div className="border-t border-border/40 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-muted-foreground">
              © 2024 Bahama Marketplace. All rights reserved.
            </div>
            <div className="flex items-center space-x-8 text-sm">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;